<div class="module-info-column">
  <div class="body-3" [ngClass]="row[columnConfig.id].active ? 'active' : 'inactive'">
    {{ (row[columnConfig.id].active ? "Status aktiv" : "Status inaktiv") | translate }}
  </div>
  <div class="body-3" [class.inactive-division]="!row[columnConfig.id].divisions">
    <span>Sparten:&nbsp;</span>
    <span>{{ row[columnConfig.id].divisions || "-" }}</span>
  </div>
</div>
